import { memo } from 'react';

import { useLanguage } from 'assets/languages';
import CampaignFormFieldGroup from '../../../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import MandatoryPhraseField from '../../../formFields/mandatoryPhraseField/mandatoryPhraseField';

const TextGuidelineFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };

  return (
    <CampaignFormFieldGroup
      label={languageTexts.create_text_guidelines}
      wrapperClassName="!gap-7"
    >
      {/* 포스팅에 꼭 들어가야할 필수 문구 */}
      <MandatoryPhraseField />
    </CampaignFormFieldGroup>
  );
};

export default memo(TextGuidelineFieldGroup);
